import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, interval } from 'rxjs';
import moment from 'moment-timezone';
import { ONE_SECOND } from '../constants';
import { ConfigurationRoot } from '../models/configuration-root';
import { environment } from '../../../environments/environment';
import { UserInfo } from '../../generated/configuration/user-info';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private readonly configurationUrl: string = environment.urls.configurationUrl;
  private config: ConfigurationRoot;

  public serverDateTimeBehaviorSubject: BehaviorSubject<moment.Moment> = new BehaviorSubject<moment.Moment>(null);

  constructor(
    private http: HttpClient,
  ) {}

  /** Выполняет инициализацию сервиса. */
  public async init(): Promise<any> {
    try {
      this.config = await this.http.get<ConfigurationRoot>(this.configurationUrl).toPromise();

      this.serverDateTimeBehaviorSubject.next(
        moment.tz(this.config.serverMoscowTime, 'Europe/Moscow')
      );
      this.startServerDateTimeInterval();

    } catch (error) {
      throw error;
    }
  }

  /** Считает текущую серверную дату и время */
  private startServerDateTimeInterval() {
    interval(ONE_SECOND).subscribe(() => {
      const currentTime = this.serverDateTimeBehaviorSubject.getValue().clone();
      this.serverDateTimeBehaviorSubject.next(currentTime.seconds(currentTime.seconds() + 1));
    });
  }

  /** Возвращает экземпляр конфигурации */
  get configuration(): ConfigurationRoot {
    return this.config;
  }

  /** Возвращает перечисления */
  get enums(): any {
    return this.config?.enums;
  }

  get user(): UserInfo {
    return this.config?.user;
  }
}
